(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8731],{

/***/ 3959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/snippets/poshmark-one-item-bundle/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2021-07-08",
      tag: "Poshmark Snippets",
      title: "What do I do with Single Item Bundles on Poshmark?",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: " Did someone leave you hanging with a single listing in a bundle? Here's what it could mean."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "They were browsing your closet, but got interrupted!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: " It's very easy to get distracted, it's entirely possible that they simply forgot about the bundle."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "They were expecting a discount"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It's also very possible that they were hoping for a discount as well."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: " What you can do? "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: " Make an offer! "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [' ', "Even though it's a single listing, you can still give a private discount to buyers without a public price drop!"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: " Write a comment "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: " Ask them to take another look at your closet and let them know of any bundle discounts you give!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: " Best of luck, and happy selling!"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/poshmark-one-item-bundle.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "What do I do with Single Item Bundles on Poshmark? | OneShop Blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Did someone leave you hanging with a single item bundle? Here\u2019s what it could mean and what you can do!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/poshmark-one-item-bundle"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/poshmark-one-item-bundle"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "What do I do with Single Item Bundles? | OneShop Blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Did someone leave you hanging with a single item bundle? Here\u2019s what it could mean and what you can do!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2021-07-08T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2021-07-08T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 52741:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/poshmark-one-item-bundle",
      function () {
        return __webpack_require__(3959);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(52741); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);